import { render, staticRenderFns } from "./xinpengzhiyunDetails.vue?vue&type=template&id=e968279e"
import script from "./xinpengzhiyunDetails.vue?vue&type=script&lang=js"
export * from "./xinpengzhiyunDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports